import {BaseModule} from "./base/base";

export class HalfWrapper extends BaseModule {
    constructor(selector = '.half-wrapper') {
        super();
        const target = document.querySelector(selector) as HTMLElement;
        if (target) {
            window.addEventListener('resize', () => {
                this.resize(target);
            });

            this.resize(target);
            setTimeout(() => {
                this.resize(target);
            }, 400);
            setTimeout(() => {
                this.resize(target);
            }, 800);
            setTimeout(() => {
                this.resize(target);
            }, 1200);
        }
    }

    resize(target: HTMLElement) {
        const relSelector = target.getAttribute('data-relative');
        const relative = relSelector ? document.querySelector(relSelector) as HTMLElement : null;
        target.style.height = 'auto';
        if (relative) {
            relative.style.height = 'auto';
        }

        if (window.innerWidth > 1023) {
            const height = target.offsetHeight;
            target.style.height = Math.floor(height / 2) + 'px';

            if (relative) {
                relative.style.height = Math.floor(height / 2) + 'px';
            }
        }
    }
}
